import { ActiveExpeditionInfo } from "./components/ActiveExpeditionInfo";
import { FinishedExpeditionInfo } from "./components/FinishedExpeditionInfo";
import styles from "../ExpeditionDetails/ExpeditionDetails.module.css";
import { Expedition } from "../../types";

interface ExpeditionInfoProps {
	expedition: Expedition;
	setExpedition: React.Dispatch<React.SetStateAction<Expedition | null>>;
}

export const ExpeditionInfo: React.FC<ExpeditionInfoProps> = ({
	expedition,
	setExpedition,
}) => {
	return (
		<div className={styles.infoWrapper}>
			<div className={styles.infoContainer}>
				{expedition?.user_metadata?.status === "OPEN" ||
				expedition?.user_metadata?.status === "IN_PROGRESS" ? (
					<ActiveExpeditionInfo
						expedition={expedition}
						setExpedition={setExpedition}
					/>
				) : expedition?.user_metadata?.status === "CLOSED" ? (
					<FinishedExpeditionInfo
						expedition={expedition}
						isVisible
						setExpedition={setExpedition}
					/>
				) : (
					""
				)}
			</div>
		</div>
	);
};
